import React, { useEffect, useRef, useState } from 'react';
import { retrieveSftyRulDtl } from '../../api/FnSmartTBM';
import { IoIosArrowForward, IoIosArrowBack } from 'react-icons/io';
import axios from "axios";
import { useDidMountEffect } from '../../hook/useDidMountEffect';

export default function SmrtTBMSftyRul({ doneTBM, agrd, setAgrd, setReadSftyRulList, readSftyRulList, fileDataList, setFileDataList, sftyRulDataList, setSftyRulDataList, sctrGb }: any) {
  const [sftyRulDtlData, setSftyRulDtlData] = useState<any>();
  const [backArrowState, setBackArrowState] = useState(false);
  const [forwardArrowState, setForwardArrowState] = useState(true);
  const inputRef = useRef<any>();
  const inputClick = () => { inputRef.current.click(); };

  useEffect(() => {
    retrieveSftyRulDtl(sctrGb, setSftyRulDtlData, setFileDataList, setReadSftyRulList, readSftyRulList, setSftyRulDataList);
  }, [])
  useDidMountEffect(() => {
    if (sftyRulDtlData === undefined && sftyRulDataList.length === 0) { setAgrd((prevState: any) => ({ ...prevState, 3: true })) }
    else if (sftyRulDataList && sftyRulDataList.length === 1) { setForwardArrowState(false); }
  }, [sftyRulDataList])

  const arrowHandler = (dir: string) => {
    let index = sftyRulDataList.findIndex((i: any) => i.seq === sftyRulDtlData?.seq)
    if (index !== 0 && dir === 'back') {
      setSftyRulDtlData({ title: sftyRulDataList[index - 1].title, seq: sftyRulDataList[index - 1].seq, atchFileId: sftyRulDataList[index - 1].atchFileId })
    } else if (index !== sftyRulDataList.length - 1 && dir === 'forward') {
      setSftyRulDtlData({ title: sftyRulDataList[index + 1].title, seq: sftyRulDataList[index + 1].seq, atchFileId: sftyRulDataList[index + 1].atchFileId })
    }
  };

  useEffect(() => {
    let index = sftyRulDataList.findIndex((i: any) => i.seq === sftyRulDtlData?.seq)
    if (index === 0) { setBackArrowState(false); setForwardArrowState(true); }
    else if (index !== 0 && index !== sftyRulDataList.length - 1) { setBackArrowState(true); setForwardArrowState(true); }
    else if (index === sftyRulDataList.length - 1) { setBackArrowState(true); setForwardArrowState(false); }
  }, [sftyRulDtlData]);

  useEffect(() => {
    setReadSftyRulList(readSftyRulList.concat(sftyRulDtlData?.seq))
    if (sftyRulDtlData) {
      fn_retrieveFilDataList(sftyRulDtlData.atchFileId)
    }
  }, [sftyRulDtlData])

  const fn_retrieveFilDataList = async (atchFileId: any) => {
    const rtrnData = await axios.post('admin/api/cmmn/fileInfoForTableView', { atchFileId: atchFileId });
    setFileDataList(rtrnData.data.fileList);
  }

  return (
    <div className='flex flex-col justify-center items-center w-[260px] sm:w-[318px] md:w-[750px] '>
      {sftyRulDataList?.length === 0 ? <p className='w-[90%] mt-32 text-15 leading-18 md:mt-[80px] md:text-37 md:leading-45 font-preBold'>등록된 안전수칙이 없습니다.</p>
        : <>
          <p className='w-[90%] mt-32 text-15 leading-18 md:mt-[80px] md:text-37 md:leading-45 font-preBold'>제목<span className='ml-24 md:ml-[60px] font-preLight'>{sftyRulDtlData?.title}</span></p>
          <p className='w-[90%] mt-16 text-15 leading-18 md:mt-[50px] md:text-37 md:leading-45 font-preBold mb-17'>내용</p>
          <div className='w-[100%] flex justify-between items-center'>
            {sftyRulDataList?.length === 1 ? <div className='text-30 md:text-75'>&nbsp;&nbsp;&nbsp;&nbsp;</div>
              : backArrowState ? <IoIosArrowBack className='text-30 md:text-75 text-[#C3C3C3]' onClick={() => arrowHandler('back')} /> : <div className='text-30 md:text-75'>&nbsp;&nbsp;&nbsp;&nbsp;</div>}
            <div className='w-[90%] flex flex-col justify-center md:text-37'>{
              fileDataList.map((fileData: any) => (
                <img key={fileData.fileSn} alt='file' src={`admin/api/cmmn/fileDownload?atchFileId=${fileData.atchFileId}&fileSn=${fileData.fileSn}`} className='object-cover' />
              ))
            }
            </div>
            {sftyRulDataList?.length === 1 ? <div className='text-30 md:text-75'>&nbsp;&nbsp;&nbsp;&nbsp;</div>
              : forwardArrowState ? <IoIosArrowForward className='text-30 md:text-75 text-[#C3C3C3]' onClick={() => arrowHandler('forward')} /> : <div className='text-30 md:text-75'>&nbsp;&nbsp;&nbsp;&nbsp;</div>}
          </div>
          {/*{!doneTBM && <div className='flex w-full mt-25 md:mt-[62px]'>*/}
          {/*  {!agrd[3] ? <input ref={inputRef} onChange={() => setAgrd((prevState: any) => ({ ...prevState, 3: !agrd[3] }))} type='checkbox' className='accent-point md:w-[40px]' />*/}
          {/*    : <input ref={inputRef} onChange={() => setAgrd((prevState: any) => ({ ...prevState, 3: !agrd[3] }))} type='checkbox' className='accent-point md:w-[40px]' defaultChecked />}*/}
          {/*  <p onClick={inputClick} className='ml-10 md:ml-[25px] text-[#9C9C9B] text-13 leading-15 md:text-32 md:leading-37 font-preLight underline underline-offset-1 decoration-[#9C9C9B] decoration-[0.5px]'>모든 안전수칙을 확인하고, 숙지하였습니다.</p>*/}
          {/*</div>}*/}
        </>
      }
    </div>
  );
}

